var $ = jQuery = require('jquery');

angular.module('blc').directive('quoteForm',quoteformdir)
quoteformdir.$inject = ['phone_prefixes', 'available_languages', 'browser','quote'];
function quoteformdir(phone_prefixes, available_languages, browser, quote) {
  $('body').on('change', '#choose_country', function () {
    var elm = $(this).find('option:selected');
    var ext = $(elm).data('phone');
    elm.text(' (+' + ext + ')');
    $(this).next('[type=tel]').focus();
  });
  return {
    transclude:  true,
    restrict:    'E',
    replace:     true,
    templateUrl: '/quote-form.html',
    scope: {
      car:   '=?car',
      hide:  '@'
    },
    controller: ['$scope','$element', function($scope, $element) {
      if ($scope.hide) $element.addClass('mfp-hide');
      if (!$scope.quote) $scope.quote = quote;
      if (!$scope.car)   $scope.car   = $scope.quote.car;

      $scope.phone_prefixes = phone_prefixes;
      $scope.available_languages = available_languages;
      $scope.current_date = null;

      if ($scope.quote.popupcar) show_quote_form();
      
      browser.getData.then(function(data) {
        $scope.client_data = data.data;
        if (!$scope.quote.personal.phone_prefix) {
          var found_country = $scope.phone_prefixes.find_by_prop('iso', data.data.country_code);
          if (found_country) {
            $scope.quote.personal.phone_prefix = found_country.code;
          }
        }
        setTimeout(function() { $('select', $element).trigger('change'); }, 500); // set phone prefix
      });
        
      $scope.phone_prefix_code = function() { 
        var found_region = phone_prefixes.find_by_prop("code", $scope.quote.personal.phone_prefix); 
        return found_region ? found_region.iso.toLowerCase() : null; 
      };
    }],
  };
}




/*****************
 ** WEBPACK FOOTER
 ** ./gulp/assets/javascripts/quote_directive.js
 ** module id = 23
 ** module chunks = 0
 **/